
import emptyState from './emptyState';
import { actionTypes } from './actions';
import { immutableSet } from '../../../utils/immutable';


interface IAction {
    type: any,
    payload: any,
}

const ACTION_HANDLERS = {
    [actionTypes.SHOW_AND_CLOSE_LOADER_WRAPPER]: (state: any) => immutableSet(['loaderWrapper', 'show'], true, state),
};



// Reducer
export default function communicationReducer(state = emptyState, action: IAction) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(action) : state;
};
